<script setup>
import { onMounted } from 'vue'
import WebGLFluid from 'webgl-fluid'
onMounted(() => {
  const canvas = document.getElementById('webgl-fluid')
  const config = {
    TRANSPARENT: true,
    IMMEDIATE: false,
    TRIGGER: 'hover',
    SIM_RESOLUTION: 128,
    DYE_RESOLUTION: 1024,
    CAPTURE_RESOLUTION: 512,
    DENSITY_DISSIPATION: 1,
    VELOCITY_DISSIPATION: 1,
    PRESSURE: 1,
    PRESSURE_ITERATIONS: 20,
    CURL: 30,
    SPLAT_RADIUS: 0.25,
    SPLAT_FORCE: 4000,
    SHADING: true,
    COLORFUL: true,
    COLOR_UPDATE_SPEED: 100,
    PAUSED: false,
    BACK_COLOR: {
      r: 0,
      g: 0,
      b: 0
    },
    BLOOM: true,
    BLOOM_ITERATIONS: 4,
    BLOOM_RESOLUTION: 256,
    BLOOM_INTENSITY: 0.8,
    BLOOM_THRESHOLD: 0.6,
    BLOOM_SOFT_KNEE: 0.7,
    SUNRAYS: false,
    SUNRAYS_RESOLUTION: 0,
    SUNRAYS_WEIGHT: 0
  }
  WebGLFluid(canvas, config)
})

</script>

<template>
  <canvas id="webgl-fluid"></canvas>
</template>

<style scoped>


#webgl-fluid {
  width: 100%;
      height: 100%;
  position:fixed;
  inset:0;
  z-index:-1;
}

</style>